import { render } from "./info-insurance-v2.vue?vue&type=template&id=10beecf0&ts=true"
import script from "./info-insurance-v2.vue?vue&type=script&lang=ts"
export * from "./info-insurance-v2.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__